export const NotificationsEndpoints = {
  notifications: () => `/rest/v1/notifications/newclub`,
  count: () => `/rest/v1/notifications/newclub/count`,
  readAll: () => `/rest/v1/notifications/newclub/read`
}
